import React from "react";

type TooltipProps = {
  text: string;
  children?: React.ReactNode;
  position?: "top" | "bottom" | "left" | "right";
  hide?: boolean;
};

function Tooltip({
  text,
  children,
  position = "top",
  hide = false,
}: TooltipProps) {
  if (hide) return <>{children}</>;

  const positionClasses: Record<string, string> = {
    // tooltip box placement relative to trigger
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  const arrowClasses: Record<string, string> = {
    // arrow placement relative to tooltip box (slightly overlapping)
    top: "bottom-[-2px] left-1/2 -translate-x-1/2", // tooltip above trigger -> arrow at tooltip bottom
    bottom: "top-[-2px] left-1/2 -translate-x-1/2", // tooltip below trigger -> arrow at tooltip top
    left: "right-[-2px] top-1/2 -translate-y-1/2", // tooltip left of trigger -> arrow at tooltip right
    right: "left-[-2px] top-1/2 -translate-y-1/2", // tooltip right of trigger -> arrow at tooltip left
  };

  return (
    <div className="group relative inline-flex items-center">
      {children && children}

      <div
        className={`absolute ${positionClasses[position]} 
                    pointer-events-none z-10 
                    whitespace-nowrap rounded bg-gray-800 
                    px-2 py-1 text-sm 
                    text-white opacity-0 transition-opacity duration-150 
                    ease-out group-hover:opacity-100`}
      >
        {text}

        {/* arrow (rotated square) */}
        <div
          className={`absolute h-2 w-2 rotate-45 bg-gray-800 ${arrowClasses[position]}`}
        />
      </div>
    </div>
  );
}
export default Tooltip;
